import merge from 'lodash/merge.js';

import BaseActivities from '@/store/modules/base/BaseActivities.js';

export default merge(
    BaseActivities({
        name: 'ActivityTemplates',
    }),
    {}
);
